import { IMeetingDetail, IUserMeeting } from "./meeting";
import { INode } from "./node";
import { IAttendingUser, IUser } from "./user";
import {
  IQuorumResult,
  ISurvey,
  ISurveyDetail,
  ISurveyResponseDetails,
  ISurveyResponselanguage,
  ISurveyResultSingle,
  ISurveyResultTotal,
} from "./survey";
import {
  ContentDataPresentationPlayer,
  IRepositoryUser,
} from "./repositoryUser";
import { ILanguage } from "./company";
import { GalleryItemType, IGalleryElement } from "./content";
import { number } from "yargs";
import { BroadcastLauncherTypes } from "./broadcast";

export interface IPlayerSignin {
  meetings: IUserMeeting[];
  user: IUser;
  canViewODG: boolean;
  canViewArchive: boolean;
  broadcastLauncherType?: BroadcastLauncherTypes;
}

export interface IMeetingContentTreePageDto {
  title: string;
  tree: INode[];
  availableLanguages: ILanguage[];
  languageId: number;
  canDownloadZip: boolean;
  canViewTranscriptions: boolean;
}

export interface IBoardTreePageDto {
  boardId: number;
  name: string;
  tree: INode[];
  canEditNodes: boolean;
  lastUpdateDate?: Date;
  availableLanguages?: ILanguage[];
  languageId?: number;
}

export interface ISidebar {
  links: IPlayerLink[];
  canViewSurvey: boolean;
  enabledRepository: boolean;
  enabledArchive: boolean;
}

export interface IPlayerLink {
  label: string;
  link: string;
  icon: string;
}

export interface IMeetingAttendanceStatus {
  meetingId: number;
  userId: number;
  shareSyncStatus: number;
}

export interface IMeetingAttendees {
  attendees: IAttendingUser[];
  sharingUserId?: number;
}

export interface IModalActionButton {
  text: string;
  action: () => void | Promise<any>;
  color?: string;
}

export interface IHubResponse {
  code: number;
  message: string;
}

export interface ISurveyPageDto {
  surveys: ISurvey[];
  meetingTitle: string;
  canEdit: boolean;
  canClear: boolean;
  canView: boolean;
  canEvent: boolean;
  canVote: boolean;
  canViewODG: boolean
}

export interface ISurveyEditPageDto {
  languages: ILanguage[];
  survey: ISurveyDetail;
}

export interface ISurveyType {
  id: number;
  name: string;
}

export interface ISurveyResponsesDto {
  surveyResponses: ISurveyResponseDetails[];
}

export interface ISurveyEditResponseDto {
  responsesLanguages: ISurveyResponselanguage[];
}

export interface ISurveyResultTotalDto {
  totalResults: ISurveyResultTotal[];
}

export interface ISurveyResultSingleDto {
  singleResults: ISurveyResultSingle[];
}

export interface IQuorumResultDto {
  quorumDetails: IQuorumResult;
}

export interface IMeetingEditPageDto {
  languages: ILanguage[];
  meeting: IMeetingDetail;
}

export interface ISurveyResult {
  quorumDetails: IQuorumResult;
  listResultTotal: ISurveyResultTotalDto;
  listResultSingle: ISurveyResultSingleDto;
  permissions: ISurveyPermissions;
  surveyTypeId: number;
}

export interface ISurveyPermissions {
  canShareSurvey: boolean;
  canVote: boolean;
  hasVote: boolean;
}

export interface ISurveyModal {
  meetingId: number;
  nodeId: number;
}

export interface IRepositoryUserTreePageDto {
  tree: IRepositoryUser[];
}

export interface PresentationDetailDto {
  title: string;
  contentDataPresentation: ContentDataPresentationPlayer[];
}

export interface IGalleryFile {
  type: GalleryItemType;
  fileId: number;
}

export interface ISharedObject {
  fileId: number;
  type: GalleryItemType;
  data: string;
  command?: string;
  
}

// Dto per nuovo componente lista risposte multilingua
export interface SurveyReponsesPageDto{
  countResponses: number;
  surveyResponses: ResponseDto[];
}

export interface ResponseDto{

  languageId: number;
  responseLanguage: ResponseLanguageDto[];
}

export interface ResponseLanguageDto{

  id: number;
  orderPos: number;
  status: boolean;
  canEdit: boolean;
  response: string;
  index: string;
}
export interface PlayerBrowsePageDto{
  contentId: number;
  languageId: number ;
  documentName: string;
  sourceName: string;
  typology: string;
  galleryElements: IGalleryElement[];
  availableLanguages: ILanguage[];
}



export interface IZoomPortion{
  fileId: number,
  imageZwibbler: string,
  cropX: number,
  cropY: number,
  cropWidth: number,
  cropHeight: number,
  contanierWidth: number
  guestUsername ?: string
}

export class zoomPortionValue implements IZoomPortion{
  imageZwibbler: string="";
  fileId: number=0;
  cropX: number=0;
  cropY: number=0;
  cropWidth: number=0;
  cropHeight: number=0;
  contanierWidth: number=0;
  guestUsername: string =""
  constructor(init?: IZoomPortion) {
    Object.assign(this, init);
  }
 
 

}